import { NonAuthenticatedRoute } from '@rhino-project/ui-heroui';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/auth')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: (search.redirect as string) || undefined
  }),
  beforeLoad: ({ context: { rhino }, search, location }) => {
    // Allow a signed-in existing user onto the accept page so they can accept
    // an invitation for their account.
    if (location.pathname.startsWith('/auth/accept-invitation')) return;

    // Redirect to previous or '/' which will find a base owner
    if (rhino.user) throw redirect({ to: search.redirect || '/' });
  },
  component: NonAuthenticatedRoute
});
